import { useApiQuery } from '~/hooks';
import { getWalletsApi } from '../repository';

export const WALLET_QUERY_KEYS = {
  WALLETS: 'wallets',
};

export const useGetWalletsQuery = () => {
  return useApiQuery({
    queryKey: [WALLET_QUERY_KEYS.WALLETS],
    queryFn: () => getWalletsApi(),
  });
};
